export default __webpack_public_path__ + "static/char-s-42-ja-f2cfb9c9794a21a353725f345516ef7f.webp";